export const searchParams = {
  SiteCode: 'filter',
  SiteName: 'siteName',
  City: 'city',
  State: 'state',
  Zip: 'zipcode',
  Country: 'country',
  OrganizationCode: 'org',
};

export const searchReverseParams = {
  filter: 'SiteCode',
  siteName: 'SiteName',
  city: 'City',
  state: 'State',
  zipcode: 'Zip',
  country: 'Country',
  org: 'OrganizationCode',
};

export const SEARCH_DEFAULT_LABEL = 'SiteCode';
export const SEARCH_DEFAULT_SEPERATOR = 'in';
export const SEARCH_DEFAULT_FOR = 'searchOption';

export const SUGGESTED_SEARCH_HINTS = {
  defaultLabel: 'SiteCode',
  defaultSeperator: 'in',
  defaultFor: 'searchOption',
};
